export default "__VITE_ASSET__Brr9IcFx__"